import React from 'react';
import {connect} from 'react-redux';
import {BaseLineupPlayersComponent} from 'components/organisms/lineup/components/mobile/lineup-players/sports/tennis';

class LineupPlayersComponent extends BaseLineupPlayersComponent {
    getPlayerView(player) {
        return (
            <tr key={player.playerId} className={this.getRowClassName(player)}>
                <td>
                    <strong>{player.name}</strong>
                </td>
                <td>{player.positionInLineup}</td>
                <td>
                    <strong className="text-gray">{player.salary}</strong>/{parseFloat(player.lineupPoints).toFixed(3)}
                </td>
                <td>{player.projOwn.getValue()}</td>
            </tr>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        filterLineupsByPlayer,
    } = state;

    return {
        lineups,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
